var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header"},[_c('a-popconfirm',{attrs:{"title":"确定要退出嘛？","ok-text":"Yes","placement":"bottomLeft","cancel-text":"No"},on:{"confirm":_vm.logout}},[_c('a-button',{attrs:{"type":"primary","icon":"logout"}},[_vm._v("退出")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }